<script>
import Layout from '@/router/layouts/main';
import { required } from 'vuelidate/lib/validators';
import Repositories from '@/repositories';
const OrdersRepository = Repositories.get('orders');
const SuppliersRepository = Repositories.get('suppliers');
const ShippingLocationsRepository = Repositories.get('shippinglocations');
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Multiselect from 'vue-multiselect';

export default {
  page: {
    title: 'Orders',
  },
  components: {
    Layout,
    Loading,
    Multiselect,
  },
  data() {
    return {
      state: 'create',
      isLoading: false,
      items: [
        {
          text: 'order',
          href: '/orders/create',
        },
        {
          text: '',
          active: true,
        },
      ],
      suppliersOptions: [],
      shippingLocationsOptions: [],
      formObject: {
        supplier: null,
        shippingLocation: null,
      },
    };
  },
  validations: {
    formObject: {
      // number: { required, minLength: minLength(3) },
      supplier: { required },
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoading = true;
      let resp1 = SuppliersRepository.getAll().then((response) => {
        this.suppliersOptions = response.data.data;
      });

      let resp2 = ShippingLocationsRepository.getAll().then((response) => {
        this.shippingLocationsOptions = response.data.data;
      });

      Promise.all([resp1, resp2])
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onSubmit() {
      this.$v.formObject.$touch();
      if (!this.$v.formObject.$invalid) {
        this.isLoading = true;
        this.create();
      }
    },
    create() {
      let apiWrapper = {
        idPublic: null,
        // number: this.formObject.number,
        supplierIdPublic: this.formObject.supplier.idPublic,
      };

      if (this.formObject.shippingLocation != null) {
        apiWrapper.shippingLocationIdPublic = this.formObject.shippingLocation.idPublic;
      }

      OrdersRepository.create(apiWrapper)
        .then((resp) => {
          this.$router.push({
            name: 'manageOrder',
            params: { idPublic: resp.data.idPublic },
          });
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          this.isLoading = false;
        });
    },
    cancel() {
      this.$router.push({ name: 'orders' });
    },
  },
};
</script>

<template>
  <Layout :title="$t('general.create')">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>

    <b-form @submit.prevent="onSubmit" style="max-width: 500px">
      <b-form-group
        id="input-group-supplier"
        :label="$t('suppliers.supplier')"
        label-for="input-supplier"
      >
        <multiselect
          id="input-supplier"
          :validator="$v.formObject.supplier"
          :class="{
            'is-invalid': $v.formObject.supplier.$error,
          }"
          v-model="formObject.supplier"
          :options="suppliersOptions"
          :show-labels="false"
          :label="'name'"
          track-by="idPublic"
          :placeholder="$t('general.pickAValue')"
          :searchable="true"
          ><template v-slot:noOptions>
            {{ $t('general.noResult') }}
          </template></multiselect
        >
        <div v-if="$v.formObject.supplier.$error" class="invalid-tooltip">
          {{ $t('errors.requiredValue') }}
        </div>
      </b-form-group>

      <b-form-group
        id="input-group-shipping-location"
        :label="$t('orders.shippingLocation')"
        label-for="input-shipping-location"
      >
        <multiselect
          id="input-shipping-location"
          v-model="formObject.shippingLocation"
          :options="shippingLocationsOptions"
          :show-labels="false"
          :label="'name'"
          track-by="idPublic"
          :placeholder="$t('general.pickAValue')"
          :searchable="true"
        >
          <template v-slot:noOptions>
            {{ $t('general.noResult') }}
          </template></multiselect
        >
      </b-form-group>

      <b-button
        @click="cancel()"
        class="mr-2"
        type="button"
        variant="secondary"
        >{{ $t('general.cancel') }}</b-button
      >

      <b-button type="submit" variant="primary">{{
        $t('general.create')
      }}</b-button>
    </b-form>
  </Layout>
</template>
